import { APP_URL } from "../config";
import { getToken } from "../authBody";

export default (filePath) =>
  `${APP_URL}rest/file-system/${getToken()}/download/${filePath}`;
